/* Apply the configured campaign for every storefront entry, including fresh browsers. */
(() => {
  const config = window.YoriaCampaignConfig;
  if (!config?.enabled || !config.code) return;
  const root = window.Shopify?.routes?.root || '/';
  let pending;
  const request = async (path, options = {}) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 6000);
    try {
      const response = await fetch(root + path, { credentials: 'same-origin', ...options, signal: controller.signal });
      if (!response.ok) throw new Error('Campaign request failed: ' + response.status);
      return await response.json();
    } finally { clearTimeout(timer); }
  };
  const ensure = () => {
    if (pending) return pending;
    pending = (async () => {
      const before = await request('cart.js');
      const codes = (before.discount_codes || []).map(item => item.code).filter(Boolean);
      if (codes.some(code => code.toLowerCase() === config.code.toLowerCase())) return { cart: before, changed: false };
      codes.push(config.code);
      const cart = await request('cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: codes.join(','), attributes: { yoria_campaign_discount: config.code } })
      });
      if (!cart.discount_codes?.some(item => item.code?.toLowerCase() === config.code.toLowerCase())) {
        throw new Error('Campaign code was not saved');
      }
      return { cart, changed: before.total_price !== cart.total_price || before.total_discount !== cart.total_discount };
    })();
    pending.catch(() => { pending = undefined; });
    return pending;
  };
  const discountUrl = destination => root + 'discount/' + encodeURIComponent(config.code) + '?redirect=' + encodeURIComponent(destination);
  window.YoriaCampaign = { ensure, discountUrl };
  const initial = ensure();
  initial.catch(error => console.warn('YORIA campaign could not be initialized', error));
  const bind = () => {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (!form.querySelector('[name="return_to"]')) {
        const input = document.createElement('input');
        input.type = 'hidden'; input.name = 'return_to'; input.value = discountUrl(root + 'cart');
        form.appendChild(input);
      }
    });
    const replaying = new WeakSet();
    document.querySelectorAll('form[action*="/cart"]').forEach(form => {
      form.addEventListener('submit', async event => {
        if (replaying.has(form)) { replaying.delete(form); return; }
        if (event.defaultPrevented || event.submitter?.name !== 'checkout') return;
        event.preventDefault();
        try {
          await ensure();
          replaying.add(form);
          form.requestSubmit(event.submitter);
        } catch (error) {
          // Submit quantities before the native discount route sends the shopper to checkout.
          const response = await fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
          if (response.ok) window.location.assign(discountUrl(root + 'checkout'));
          else console.error('Cart update failed; please retry checkout', error);
        }
      });
    });
    if (document.querySelector('.yoria-cart__form')) {
      initial.then(result => { if (result.changed) window.location.reload(); }).catch(() => {});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, { once: true });
  else bind();
})();
